import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cta-subsection" }
const _hoisted_2 = { class: "cta-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "cta-title" }, "Prêt à transformer votre commerce floral ?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "cta-description" }, " Rejoignez les fleuristes qui réussissent avec Florisuite. Commencez votre essai gratuit ou contactez notre équipe pour une démonstration personnalisée. ", -1)
const _hoisted_5 = { class: "cta-buttons" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "cta-button-text" }, "Démarrer l'essai gratuit", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "cta-button-text" }, "Contacter le Support", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "cta-button primary",
          to: "/inscription"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "cta-button secondary",
          to: "/contact"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}